'use client'

import clsx from 'clsx'
import { useEffect, useRef } from 'react'

export const HotspotItem = ({ hotspot, isFirst }) => {
  const itemRef = useRef(null)

  const hotspotOptions = {
    pointClass: 'hotspots-point',
    contentClass: 'hotspots-content',
    contentPositionTreshold: 50,
    mediaViewChange: 768,
    firstIsOpen: true,
  }

  useEffect(() => {
    const node = itemRef.current
    if (!node) return

    const point = node.querySelector(`.${hotspotOptions.pointClass}`)
    const content = node.querySelector(`.${hotspotOptions.contentClass}`)

    setPointPosition(point, content, {
      top: point.getAttribute('data-position-top'),
      left: point.getAttribute('data-position-left'),
    })

    // close on esc
    document.addEventListener('keydown', (event) => {
      if (window.matchMedia(`(min-width: ${hotspotOptions.mediaViewChange}px)`).matches) {
        if (event.key === 'Escape') {
          close(node, true)
        }
      }
    })
  })

  const toggle = (item) => {
    const isOpen = item.classList.contains('active')
    if (isOpen) {
      close(item)
    } else {
      open(item)
    }
  }

  const open = (item) => {
    item.classList.add('active')
  }

  const close = (item) => {
    item.classList.remove('active')
  }

  const setPointPosition = (point, content, pos) => {
    const elem = point
    const contentElem = content

    // To prevent a mismatch in spacing between the point and the content-block, we need to get the point size
    // either from the element itself or from the CSS variable, if the page is opened first on mobile
    // and resized to desktop - the point width will be 0, but the CSS variable will always be set.

    const styles = getComputedStyle(elem)
    const variableValue = styles.getPropertyValue('--hotspots-element__item__point__size').trim()
    const variableValueNumber = Number(variableValue.replace('px', ''))
    const pointSize = elem.offsetWidth || variableValueNumber

    elem.style.top = `calc(${pos.top}% - ${pointSize / 2}px)`
    elem.style.left = `calc(${pos.left}% - ${pointSize / 2}px)`

    if (contentElem) {
      const directions = ['top', 'right', 'bottom', 'left']

      directions.forEach((direction) => {
        const oppositeDirection = `direction-from-${direction === 'top' ? 'bottom' : 'right'}`
        const position = pos[direction]

        if (position > hotspotOptions.contentPositionTreshold) {
          contentElem.classList.add(oppositeDirection)
          contentElem.style[direction === 'top' || direction === 'bottom' ? 'bottom' : 'right'] =
            `${100 - position}%`
        } else {
          contentElem.classList.add(`direction-from-${direction}`)
          contentElem.style[direction === 'top' || direction === 'bottom' ? 'top' : 'left'] =
            `${position}%`
        }
      })
    }
  }

  const nodeOnClick = () => {
    toggle(itemRef.current)
  }

  return (
    <div
      key={hotspot.id}
      className={clsx('hotspots-item', isFirst && 'active')}
      ref={itemRef}
      onClick={nodeOnClick}
    >
      <div
        data-position-left={hotspot.positionX}
        data-position-top={hotspot.positionY}
        className="hotspots-point"
      >
        <span className="icon-css-plus"></span>
      </div>
      <div className="hotspots-content">
        <h3>
          {hotspot.heading}
          <span className="mobile-toggle"></span>
        </h3>
        <p>{hotspot.description}</p>
      </div>
    </div>
  )
}

export default HotspotItem
